// test2484
(2484 && 0);
